"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var compLayoutUtils_1 = require("./compLayoutUtils");
var bottomConsideringNegativeBottomTop = function (component, negativeBottomTops) { return compLayoutUtils_1.bottom(component) - (negativeBottomTops[component.id] || 0); };
var getCompsPushingNextPointTop = function (remainingPushingComps, nextTopPoint, negativeBottomTops) {
    var compBottomInNextRowIndex = _.findIndex(remainingPushingComps, function (comp) { return bottomConsideringNegativeBottomTop(comp, negativeBottomTops) > nextTopPoint; }); // TODO findSortedIndex
    return compBottomInNextRowIndex > 0 ? remainingPushingComps.splice(0, compBottomInNextRowIndex) : null;
};
var setPushingCompsPoint = function (pushingCompsPoints, pushingCompsSortedByBottom, negativeBottomTops) {
    var groupMostBottomY = bottomConsideringNegativeBottomTop(_.last(pushingCompsSortedByBottom), negativeBottomTops);
    pushingCompsPoints[groupMostBottomY] = pushingCompsSortedByBottom;
    return groupMostBottomY;
};
var getPushingCompsPointsMap = function (sortedTopPoints, components, negativeBottomTops) {
    // ascending order of components by their bottoms in regard to their negative bottom-top
    var sortedByBottom = _.sortBy(components, function (component) { return bottomConsideringNegativeBottomTop(component, negativeBottomTops); });
    var _a = _.reduce(sortedTopPoints, function (_a, nextTopPoint) {
        var remainingCompsToGroup = _a.remainingCompsToGroup, pushingCompsPoints = _a.pushingCompsPoints, pushMargins = _a.pushMargins;
        var pushingComps = getCompsPushingNextPointTop(remainingCompsToGroup, nextTopPoint, negativeBottomTops);
        if (pushingComps) {
            var pushingCompsGroupBottom = setPushingCompsPoint(pushingCompsPoints, pushingComps, negativeBottomTops);
            pushMargins[pushingCompsGroupBottom] = nextTopPoint - pushingCompsGroupBottom;
        }
        return { remainingCompsToGroup: remainingCompsToGroup, pushingCompsPoints: pushingCompsPoints, pushMargins: pushMargins };
    }, { remainingCompsToGroup: sortedByBottom, pushingCompsPoints: {}, pushMargins: {} }), remainingCompsToGroup = _a.remainingCompsToGroup, pushingCompsPoints = _a.pushingCompsPoints, pushMargins = _a.pushMargins;
    if (!_.isEmpty(remainingCompsToGroup)) {
        setPushingCompsPoint(pushingCompsPoints, remainingCompsToGroup, negativeBottomTops);
    }
    return { pushingCompsPoints: pushingCompsPoints, pushMargins: pushMargins };
};
var getSortedTopPoints = function (startingCompsPointsMap, zeroHeightCompsPointsMap) { return (_(startingCompsPointsMap)
    .keys()
    .union(_.keys(zeroHeightCompsPointsMap))
    .map(_.toNumber)
    .sortBy()
    .value()); };
var getAllGridPoints = function (topPoints, pushingCompsPointsMap) { return (_(pushingCompsPointsMap)
    .keys()
    .map(_.toNumber)
    .union(topPoints)
    .value()); };
var calculateGridPoints = function (gridComponents, negativeBottomTops) {
    var _a = _.partition(gridComponents, function (component) { return compLayoutUtils_1.height(component) === 0; }), zeroHeightComponents = _a[0], components = _a[1];
    var startingCompsPointsMap = _.groupBy(components, compLayoutUtils_1.top);
    var zeroHeightCompsPointsMap = _.groupBy(zeroHeightComponents, compLayoutUtils_1.top);
    var sortedTopPoints = getSortedTopPoints(startingCompsPointsMap, zeroHeightCompsPointsMap); // sorted y values of components. just the y vals.
    var _b = getPushingCompsPointsMap(sortedTopPoints, components, negativeBottomTops), pushingCompsPointsMap = _b.pushingCompsPoints, pushMargins = _b.pushMargins;
    var gridPoints = getAllGridPoints(sortedTopPoints, pushingCompsPointsMap);
    var gridPointDataCreator = _.partial(createGridPointData, pushingCompsPointsMap, pushMargins, zeroHeightCompsPointsMap, startingCompsPointsMap);
    return _(gridPoints)
        .map(gridPointDataCreator)
        .sortBy('y')
        .value();
};
var createGridPointData = function (pushingCompsPointsMap, pushMargins, zeroHeightCompsTops, nonZeroHeightCompsTops, y) { return ({
    y: y,
    pushingComps: pushingCompsPointsMap[y] || null,
    pushMargin: pushMargins[y] || 0,
    zeroHeightComps: zeroHeightCompsTops[y] || null,
    startingComps: nonZeroHeightCompsTops[y] || null
}); };
exports.default = calculateGridPoints;
//# sourceMappingURL=calculateGridPoints.js.map